import { AxiosResponse } from "axios";
import apiClient from "./apiClient";
import i18n from "../../i18n";
import { GetResponse } from "./response";

export interface ArItem {
  id: number;
  parentId?: number;
  typeId?: number;
  typeCode?: number;
  shortValue?: string;
  name?: string;
  displayName?: string;
  rco?: string;
  rca?: string;
}

const arGet = async (
  path: string,
  params: Record<string, string | number | undefined>,
): Promise<ArItem[]> => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const qs = search.toString();
  const response: AxiosResponse<GetResponse | ArItem[]> = await apiClient.get(
    `${process.env.REACT_APP_URL_REFERENCE_SERVICE}/reference/ar/${path}${qs ? `?${qs}` : ""}`,
    {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
      },
      withCredentials: true,
    },
  );
  const data = response.data as any;
  return Array.isArray(data) ? data : [];
};

export const mapArOptions = (items: ArItem[]) =>
  items.map((item) => ({
    value: item.id,
    label: item.displayName || [item.shortValue, item.name].filter(Boolean).join(" "),
    typeCode: item.typeCode,
    name: item.name,
    displayName: item.displayName,
    shortValue: item.shortValue,
    rca: item.rca,
  }));

/** 1. Области / города респ. значения */
export const getArRegions = (query: string) =>
  arGet("regions", { query });

/** 2. Районы / города по области */
export const getArDistricts = (parentId: number, query: string) =>
  arGet("districts", { parentId, query });

/** 3. Населённые пункты */
export const getArLocalities = (parentId: number, query: string) =>
  arGet("localities", { parentId, query });

/** 4. Улицы / СЧНП */
export const getArGeonims = (atsId: number, query: string) =>
  arGet("geonims", { atsId, query });

/** 5. Здания / дома */
export const getArBuildings = (geonimId: number, query: string) =>
  arGet("buildings", { geonimId, query });

/** 6. Помещения */
export const getArPremises = (buildingId: number, query: string) =>
  arGet("premises", { buildingId, query });
